import React from 'react'
import Alert from 'react-bootstrap/Alert'
import styled from 'styled-components'
import { colors } from '../styleGuide'

export interface DcAlertProps {
  className?: string
  variant?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'dark'
    | 'light'
    | string
  children?: React.ReactNode
  style?: React.CSSProperties
  padding?: string
}

export const DcAlert = React.forwardRef<HTMLDivElement, DcAlertProps>(
  (props, ref) => {
    const {
      variant = 'primary',
      children = 'Dc Alert',
      style,
      className,
      padding
    } = props

    return (
      <StyledAlert
        className={className}
        ref={ref}
        variant={variant}
        style={style}
        padding={padding}
      >
        {children}
      </StyledAlert>
    )
  }
)
const StyledAlert = styled(Alert)<{ variant: string; padding: string }>`
  padding: ${(props) => props.padding && props.padding};

  --bs-primary-text-emphasis: ${colors.bsPrimaryTextEmphasis};
  --bs-secondary-text-emphasis: ${colors.bsSecondaryTextEmphasis};
  --bs-success-text-emphasis: ${colors.bsSuccessTextEmphasis};
  --bs-info-text-emphasis: ${colors.bsInfoTextEmphasis};
  --bs-warning-text-emphasis: ${colors.bsWarningTextEmphasis};
  --bs-danger-text-emphasis: ${colors.bsDangerTextEmphasis};
  --bs-light-text-emphasis: ${colors.bsLightTextEmphasis};
  --bs-dark-text-emphasis: ${colors.bsDarkTextEmphasis};
  --bs-primary-bg-subtle: ${colors.bsPrimaryBgSubtle};
  --bs-secondary-bg-subtle: ${colors.bsSecondaryBgSubtle};
  --bs-success-bg-subtle: ${colors.bsSuccessBgSubtle};
  --bs-info-bg-subtle: ${colors.bsInfoBgSubtle};
  --bs-warning-bg-subtle: ${colors.bsWarningBgSubtle};
  --bs-danger-bg-subtle: ${colors.bsDangerBgSubtle};
  --bs-light-bg-subtle: ${colors.bsLightBgSubtle};
  --bs-dark-bg-subtle: ${colors.bsDarkBgSubtle};
  --bs-primary-border-subtle: ${colors.bsPrimaryBorderSubtle};
  --bs-secondary-border-subtle: ${colors.bsSecondaryBorderSubtle};
  --bs-success-border-subtle: ${colors.bsSuccessBorderSubtle};
  --bs-info-border-subtle: ${colors.bsInfoBorderSubtle};
  --bs-warning-border-subtle: ${colors.bsWarningBorderSubtle};
  --bs-danger-border-subtle: ${colors.bsDangerBorderSubtle};
  --bs-light-border-subtle: ${colors.bsLightBorderSubtle};
  --bs-dark-border-subtle: ${colors.bsDarkBorderSubtle};
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 0.75rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.375rem;
  --bs-alert-link-color: inherit;
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
  color: var(--bs-alert-color);
  margin-bottom: var(--bs-alert-margin-bottom);
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  position: relative;
  //variant
  background-color: ${(props) =>
    props.variant === 'primary' && 'var(--bs-primary-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'secondary' && 'var(--bs-secondary-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'success' && 'var(--bs-success-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'info' && 'var(--bs-info-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'warning' && 'var(--bs-warning-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'danger' && 'var(--bs-danger-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'light' && 'var(--bs-light-bg-subtle)'};
  background-color: ${(props) =>
    props.variant === 'dark' && 'var(--bs-dark-bg-subtle)'};
  color: ${(props) =>
    props.variant === 'primary' && 'var(--bs-primary-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'secondary' && 'var(--bs-secondary-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'success' && 'var(--bs-success-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'info' && 'var(--bs-info-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'warning' && 'var(--bs-warning-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'danger' && 'var(--bs-danger-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'light' && 'var(--bs-light-text-emphasis)'};
  color: ${(props) =>
    props.variant === 'dark' && 'var(--bs-dark-text-emphasis)'};
  border: ${(props) =>
    props.variant === 'primary' && '1px solid var(--bs-primary-border-subtle)'};
  border: ${(props) =>
    props.variant === 'secondary' &&
    '1px solid var(--bs-secondary-border-subtle)'};
  border: ${(props) =>
    props.variant === 'success' && '1px solid var(--bs-success-border-subtle)'};
  border: ${(props) =>
    props.variant === 'info' && '1px solid var(--bs-info-border-subtle)'};
  border: ${(props) =>
    props.variant === 'warning' && `1px solid ${colors.warningLight} !important`};
  border: ${(props) =>
    props.variant === 'danger' && '1px solid var(--bs-danger-border-subtle)'};
  border: ${(props) =>
    props.variant === 'light' && '1px solid var(--bs-light-border-subtle)'};
  border: ${(props) =>
    props.variant === 'dark' && '1px solid var(--bs-dark-border-subtle)'};
`

export default DcAlert
